<template>
  <div :class="'eb-step '+ statusClass">
    <div class="eb-step__icon">{{index + 1}}</div>
    <div class="eb-step__title">{{title}}</div>
    <div class="eb-step__bar"></div>
    <slot v-show="this.index === this.active"></slot>
  </div>
</template>

<script>
export default {
  name: "EbStep",
  props: {
    title: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      index: -1
    };
  },
  computed: {
    statusClass() {
      if (this.index === this.active) {
        return "active";
      }

      if (this.index < this.active) {
        return "finish";
      }

      return "";
    },
    active() {
      return this.$parent.active;
    }
  },
  watch: {},
  beforeCreate() {
    this.$parent.steps.push(this);
  },
  beforeDestroy() {
    const { steps } = this.$parent;
    const index = steps.indexOf(this);
    if (index >= 0) {
      steps.splice(index, 1);
    }
  },
  mounted() {}
};
</script>


<style lang="less" scoped>
@grey: #b4b4b4;
@white: #fff;
@dark: #000;

.eb-step {
  flex: 1;
  display: flex;
  align-items: center;
  &:last-child {
    flex: inherit;
  }
  &.active {
    .eb-step__icon {
      background-color: @dark;
      color: @white;
    }
    .eb-step__title {
      color: @dark;
    }
  }
  &.finish {
    .eb-step__icon {
      border-color: @dark;
      color: @dark;
    }
    .eb-step__title {
      color: @dark;
    }
    .eb-step__bar {
      background-color: @dark;
    }
  }
  .eb-step__icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 34px;
    height: 34px;
    border: 1px solid @grey;
    color: @grey;
    border-radius: 50%;
    font-size: 18px;
  }
  .eb-step__title {
    color: @grey;
    font-size: 16px;
    margin-left: 6px;
  }
  .eb-step__bar {
    flex: 1;
    height: 2px;
    background-color: @grey;
    margin: 0 20px;
  }
}
</style>
